import React from 'react'
import hoc from '@hoc'
import PropTypes from 'prop-types'
import * as utils from '@utils'
import { FormControl, FormLabel, InputLabel, Select, MenuItem } from '@material-ui/core'
import { TreeSelect } from 'antd'
import 'antd/dist/antd.css'
import { API } from '@const'

class AgentsMultiSelect extends React.Component {
    constructor(props) {
        super(props)
        this.t = (key, options) => {
            return utils.t(key, 'AgentsMultiSelect', options)
        }
		this.state = {
            loading: false,
            agentList: [],
			treeData: [],
            pfId: '',
            agentId: [],
            checkedList: [],
		}
    }

    componentDidMount() {
		this.handleGetAgentList()
    }

	handleGetAgentList() {
        if (this.state.loading) { return }
        this.setState({
            loading: true
        })
        utils.apiRequest(
            'get',
            API.AGENT_LIST,
            {},
            (data) => {
                /** 站台(幣別)排序 */
                utils.sortPlatform(data, 'pf_id')
                /** 依總代名稱排序 */
                this.handleAgentSortByName(data)
                this.props.checkedValue('pfId', data[0].pf_id)
                this.setState({
                    agentList: data,
                    pfId: data[0].pf_id,
                    loading: false
                }, () => {
                    /** 取得代理樹 */
                    this.handleAgentTree()
                })
            },
            (_err) => {
                console.log(_err)
                this.setState({
                    loading: false
                })
            },
            true
        )
    }
    /** 總代/子代名稱排序 */
    handleAgentSortByName(data) {
        data.forEach(currency=> {
            /** 各站台(幣別)底下總代排序 */
            utils.convertSort({
                source: currency.PfTopAgentList,
                sortKey: 'agent_name'
            })
        })
    }
	/** create selectTree data */
    handleAgentTree() {
        const treeData = []
        const enableAgentList = this.state.agentList.find(currency => {
            return currency.pf_id === this.state.pfId
        })?.PfTopAgentList
        enableAgentList.forEach((agent) => {
            if (agent.is_active) {
                treeData.push({
                    key: `${agent.pf_id}-${agent.agent_list_id}`,
                    value: agent.agent_list_id,
                    title: agent.agent_name,
                })
            }
        })
        const data = treeData.length > 1 ? [
            {
                key: 'all',
                value: 'all',
                title: '全部',
                children: treeData,
            }
        ] : treeData
        this.setState({
            treeData: data
        })
		// this.props.checkedValue()
    }

    render() {
        return (
            <>
                <FormControl className={this.props.classes.formControl}>
                    <InputLabel htmlFor="age-simple">{this.t('platform')}</InputLabel>
                    <Select
                        value={this.state.pfId}
                        onChange={(event) => {
                            this.props.checkedValue('pfId', event.target.value)
                            this.props.checkedValue('agentListId', [])
                            this.setState({
                                pfId: event.target.value,
                                checkedList: []
                            },() => {
                                this.handleAgentTree()
                            })
                        }}>
                        {this.state.agentList.map((items) => (
                            <MenuItem value={items.pf_id} key={items.pf_id}>
                                {this.t('Platform.' + items.pf_id) + ` (${this.t('Currency.' + utils.getPfCurrency(items.pf_id))})`}
                            </MenuItem>
                        ))}
                    </Select>
                </FormControl>
                <FormControl
                    className={this.props.classes.formControl}
                    >
                    <FormLabel className={this.props.classes.shrink}>{this.t('rootRole')}</FormLabel>
                    <TreeSelect
                        className={this.props.classes.treeSelect}
                        treeData={this.state.treeData}
                        value={this.state.checkedList}
                        onChange={(value) => {
                            this.props.checkedValue('agentListId', value)
							this.setState({
                                checkedList: value
                            })
                        }}
                        maxTagCount={1}
                        treeCheckable={true}
                        showSearch={true}
                        listHeight={64}
                        showCheckedStrategy={TreeSelect.SHOW_CHILD}
                        searchPlaceholder={this.t('pleaseSelect')}
                        dropdownStyle={{ zIndex: 3000 }}
                    />
                </FormControl>
            </>
        )
    }
}

AgentsMultiSelect.propTypes = {
    classes: PropTypes.objectOf(PropTypes.string),
    options: PropTypes.object,
	disabled: PropTypes.bool,
	checkedValue: PropTypes.func,
	checkedList: PropTypes.array,
	disabledList: PropTypes.array,
    handleGetAgentsList: PropTypes.func,
}

const styles = (theme) => {
    return {
		treeSelect: {
            width: 240,
        },
        formControl: {
            margin: theme.spacing(1),
        },
        shrink: {
            transform: 'translate(0, 1.5px) scale(0.75)',
            transformOrigin: 'top left',
        },
    }
}

export default hoc(styles)(AgentsMultiSelect)
